<template>
  <div>
    <!-- <router-link to="{{ payAuthUrl }}" replace>baidu</router-link> -->
    <!-- <van-button
        round
        block
        color="#0D7CFF"
        url={{payAuthUrl}}
        replace
      >
      baidu
      </van-button> -->
  <van-form>
    <van-cell-group inset>
      <van-field
        v-model="userInfo.name"
        name="userName"
        label="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field name="sexcode" label="性别">
        <template #input>
          <van-radio-group v-model="userInfo.sexcode" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-model="userInfo.idenno"
        name="idenno"
        label="证件号"
        type=""
        :rules="[{ required: true, message: '请填写正确的证件号',pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/ }]"
        @blur="createBirthday"
      />

      <van-field
        v-model="userInfo.telnum"
        name="telnum"
        label="手机号"
        type="tel"
        :rules="[{ required: true, message: '请输入手机号' }]"
      />
      <van-field
        v-model="userInfo.birthday"
        name="birthday"
        label="生日"
        type=""
        :rules="[{ required: true, message: '请填写生日' }]"
      />
      <van-field
        v-model="userInfo.address"
        name="address"
        label="住址"
        type=""
        :rules="[{ required: true, message: '请填写住址' }]"
      />
      <!-- <van-field
        v-model="userInfo.email"
        name="email"
        label="邮箱"
        type=""
        :rules="[{ required: true, message: '请填写邮箱' }]"
      /> -->
      <!-- <van-field v-model="userInfo.prof" name="prof" label="职业" /> -->
    </van-cell-group>
    <div style="margin: 16px">
      <van-button
        round
        block
        type="primary"
        native-type="submit"
        @click.native="saveUser"
        color="#0D7CFF"
      >
        提交
      </van-button>
    </div>
    <!-- <div style="margin: 16px; font-size: 12px;" v-if="showAuthBtn">
    如您已经申请国家医保电子凭证</br>
    您可以使用国家医保电子凭证授权进行快速添加就诊人
    </div> -->
  </van-form>
  <!-- <div style="margin: 16px"  v-if="showAuthBtn">
      <van-button
        round
        block
        color="#0D7CFF"
        url="https://mitest.wecity.qq.com/oauth/code?authType=2&isDepart=2&appid=wx2ce38300e9cedba4&cityCode=530600&channel=AAHTsc6lGr_Jxaw5xJ88dvxn&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxuncyliggt9VVj4nl0nlRGC&orgCodg=H53062700104&bizType=04107&orgAppId=1GGP9DCSG0UO3F60C80A00002CF4BCEF&redirectUrl=https://zxskyk.dmsbrowser.com/payFlow"
        replace
      >
      国家医保电子凭证授权快速添加就诊人
      </van-button>
    </div> -->
  </div>
</template>
<script>
import { ref } from "vue";
import { Form, Field, CellGroup, Button, showDialog, Dialog } from "vant";
import requests from "../../api/requests.js";
import global from "../../components/Global"; //引用模块进来

export default {
  components: {
    Form,
    Field,
    CellGroup,
    Button,
  },
  // setup() {
  //   // const userName = ref("");
  //   // const sexcode = ref("1");
  //   // const idenno = ref("");
  //   // const telnum = ref("");
  //   // const hosCode = ref("");
  //   // const address = ref("");
  //   // const email = ref("");
  //   // const prof = ref("");
  //   // let httpURL = "/His/QueryRecord?openid=123445"; //目标地址后接的详细地址
  //   // requests.get(httpURL).then(function (res) {
  //   //   console.log(res);
  //   //   userName = res.data.name;
  //   //   sexcode = res.data.sexcode;
  //   //   idenno = res.data.idenno;
  //   //   telnum = res.data.telnum;
  //   //   hosCode = res.data.hosCode;
  //   //   address = res.data.address;
  //   //   email = res.data.email;
  //   //   prof = res.data.prof;
  //   // });
  //   const onSubmit = (values) => {
  //     console.log("submit", values);
  //   };
  //   // const onLoad = () => {
  //   //   let httpURL = "/His/QueryRecord?openid=123445"; //目标地址后接的详细地址
  //   //   requests.get(httpURL).then(function (res) {
  //   //     console.log(res);
  //   //   });
  //   // };
  //   return {
  //     // userName,
  //     // sexcode,
  //     // idenno,
  //     // telnum,
  //     // hosCode,
  //     // address,
  //     // email,
  //     // prof,
  //     onSubmit,
  //   };
  // },

  data() {
    return {
      userInfo: {},
      payAuthInfo: {},
      isNewer: 1,
      showAuthBtn: false,
      //通过code获取的wx openid及token
      // tokenInfo:{},
      payAuthUrl: global.payAuthUrl,
    };
  },

  methods: {
    createBirthday() {
      this.userInfo.birthday = this.getBirthdayFromIdCard(this.userInfo.idenno);
    },
    //从建档数据里取的
    getUserInfoByOpenId(id) {
      const that = this;
      let httpURL = "/His/QueryRecord?openid=" + id;
      // requests.get(httpURL).then(res=>{
      //   this.userInfo = res.data;
      // });
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          //医院
          that.userInfo = res.data;
          that.userInfo.openid = localStorage.getItem(that.GLOBAL.hosUrl);
          that.isNewer = 0;
        } else {
          // Dialog.alert({
          //   title: "消息提示",
          //   message: res.message,
          // });
          that.showAuthBtn = true;
        }
      });
    },
    //本地存的支付信息
    // getpayAuthInfoByOpenId(id) {
    //   const that = this;
    //   let httpURL = "/PayInsurance/userQuery?openid=" + id;
    //   // requests.get(httpURL).then(res=>{
    //   //   this.userInfo = res.data;
    //   // });
    //   requests.get(httpURL).then(function (res) {
    //     console.log(res);
    //     if (res.data != null) {
    //       that.payAuthInfo = res.data;
    //       that.isNewer = 0;
    //     } else {
    //       // Dialog.alert({
    //       //   title: "消息提示",
    //       //   message: res.message,
    //       // });
    //       that.showAuthBtn = true;
    //     }
    //   });
    // },
    // 从医保授权里拿的
    mipuserQuery(id, qrcode) {
      const that = this;
      let httpURL = "/wx/MipuserQuery?openid=" + id + "&qrcode=" + qrcode;
      // requests.get(httpURL).then(res=>{
      //   this.userInfo = res.data;
      // });
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          that.payAuthInfo = res.data;

          that.userInfo.name = that.payAuthInfo.user_name;
          that.payAuthInfo.openid = id;
          // if (that.payAuthInfo.user_longitude_latitude != null) {
          //   that.payAuthInfo.longitude =
          //     that.payAuthInfo.user_longitude_latitude.longitude;
          //   that.payAuthInfo.latitude =
          //     that.payAuthInfo.user_longitude_latitude.latitude;
          // }

          that.isNewer = 1;
        } else {
          // Dialog.alert({
          //   title: "消息提示",
          //   message: res.message,
          // });
          that.showAuthBtn = true;
        }
      });
    },
    //授权信息保存到数据库
    // savePayAuth() {
    //   const that = this;
    //   let httpURL =
    //     "/PayInsurance/SavePayAuthUser?user=" +
    //     JSON.stringify(that.payAuthInfo);

    //   requests.get(httpURL).then(function (res) {
    //     Dialog.alert({
    //       title: "消息提示",
    //       message: res.message,
    //     });
    //   });
    // },

    //保存到医院的建档信息
    saveUser() {
      const that = this;
      that.userInfo.birthday = that.getBirthdayFromIdCard(that.userInfo.idenno);
      let apiName = "createrecord";
      if (this.isNewer == 0) {
        apiName = "ModifyRecord";
      }
      console.log(that.userInfo);
      let httpURL =
        "/His/" + apiName + "?record=" + JSON.stringify(that.userInfo);

      requests.get(httpURL).then(function (res) {
        Dialog.alert({
          title: "消息提示",
          message: res.message,
        });
      });
    },

    getBirthdayFromIdCard(idCard) {
      let birthday = "";
      if (idCard !== null && idCard !== "" && idCard.length === 18) {
        birthday = idCard.substr(6, 8);
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
  },
  // 1：通过code获取openid，通过openid分别获取 医院的患者信息和存在本地库的 支付信息
  // 2: 如果患者信息不存在，医保按钮展示；
  // 3：如果患者信息存在，显示患者信息；看本地库支付信息，如果存在 医保按钮不展示，不存在 医保按钮展示
  created() {
    console.log(this.payAuthUrl);
    let that = this;
    let globalOpenid = localStorage.getItem(this.GLOBAL.hosUrl);

    //第一次进来
    if (globalOpenid === "" || globalOpenid == null) {
      let code = this.$route.query.code;
      let httpURL = "/wx/wxauth?code=" + code;
      requests.get(httpURL).then(function (res) {
        if (res.data != null && res.data.openid != null) {
          that.userInfo.openid = res.data.openid;
          localStorage.setItem(that.GLOBAL.hosUrl, res.data.openid);
          that.getUserInfoByOpenId(that.userInfo.openid);
        } else {
          console.log(res);
        }
      });
    } else {
      that.userInfo.openid = globalOpenid;
      console.log(that.userInfo);
      console.log("globalVal.openid:" + globalOpenid);
      that.getUserInfoByOpenId(that.userInfo.openid);
    }

    //授权回调时 将授权信息部分展示到页面，支付信息保存到数据库
    // let authCode = this.$route.query.authCode;

    // Dialog.alert({
    //   title: "消息提示authCode",
    //   message: authCode,
    // });

    // if (authCode != "" && authCode != null) {
    //   that.mipuserQuery(globalOpenid, authCode);
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/payFlow/index.vue